import { useLocation } from 'react-router-dom';

const ExerciseStats = () => {
  const { state } = useLocation();
  const stats = state?.stats || [];

  return (
    <div className="page-content calendar-page">
      <h2>Exercise Statistics</h2>
      <div className="exercise-stats-grid">
        {stats.map(exercise => (
          <div key={exercise.exercise} className="exercise-stat-card">
            <h3>{exercise.exercise}</h3>
            <p><strong>Max Weight:</strong> {exercise.maxWeight}kg</p>
            <p><strong>Max Reps:</strong> {exercise.maxReps}</p>
            <p><strong>Max Volume:</strong> {exercise.maxVolume}kg</p>
            <p><strong>Total Volume:</strong> {exercise.totalVolume}kg</p>
            <p><strong>Total Sets:</strong> {exercise.totalSets}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExerciseStats;